import { Value } from 'slate';
import { ValueMigrator } from '@aha-app/aha-editor';

export default function isEmptyValue(value) {
  if (!value) return true;

  if (!Value.isValue(value)) {
    value = Value.fromJSON(new ValueMigrator(value).migrate());
  }

  const { document } = value;

  if (document.nodes.size > 1) return false;
  if (
    document.nodes.size === 1 &&
    document.nodes.first().type === 'paragraph' &&
    document.nodes.first().nodes.size === 1 &&
    document.nodes.first().nodes.first().object === 'text' &&
    document.text === ''
  ) {
    return true;
  }
  return false;
}
